import { SmartEditConfig } from '@spartacus/smartedit';

/**
 * Проверяет, что сайт открыт из смартедита.
 * Так как в smarteditLauncheService используется зависимость Location,
 * в которой используется APP_BASE_HREF, то образуется циркулярная зависимость.
 *
 * Логика скопирована: /feature-libs/smartedit/root/services/smart-edit-launcher.service.ts#L40
 */
export function isSmartedit(path: string, params: string | undefined, config: SmartEditConfig): boolean {
  const cmsToken = params?.split('&').find((param) => param.startsWith('cmsTicketId='));
  const cmsTicketId = cmsToken?.split('=')[1];

  return path.split('/').pop() === config.smartEdit?.storefrontPreviewRoute && !!cmsTicketId;
}
